import { Button, Modal, Text } from '@shared/widgets';

interface IDeleteThreadModalProps {
  open: boolean;
  close: () => void;
  deleteThread: () => void;
}

export const DeleteThreadModal = (props: IDeleteThreadModalProps) => {
  return (
    <Modal isOpen={props.open} onClose={props.close} title='Deleting a message'>
      <Text className='mb-5 text-center'>Are you sure you want to delete this message?</Text>
      <div className='flex gap-1'>
        <Button color='primary' fullWidth onClick={props.deleteThread}>
          Delete
        </Button>
        <Button color='primary' fullWidth onClick={props.close}>
          Close
        </Button>
      </div>
    </Modal>
  );
};
